/*
 * state loops through all js-state elements and retrieves the corresponding backend state.
 *
 * Requires element with class 'js-state'.
 * - data-state                (Name of backend-state to return)
 * - data-reverse              (Optional boolean, whether to return the reverse state)
 */

const state = () => {
  if ($('.js-state').length === 0) {
    return;
  }

  const $stateElements = $('.js-state');
  if ($stateElements.length === 0) {
    return;
  }

  let valToken = '';
  if (document.getElementsByName('__RequestVerificationToken')[0]) {
    valToken = document.getElementsByName('__RequestVerificationToken')[0].value;
  }

  const states = [];
  const statesToCheck = $stateElements.map(function iterator() {
    return $(this).data('state');
  }).get();

  for (let i = 0; i < statesToCheck.length; i += 1) {
    const currentState = statesToCheck[i];
    if (states.indexOf(currentState) === -1) {
      states.push(currentState);
      $.ajax({
        url: `/gdl-api/state/${currentState}`,
        method: 'POST',
        data: {
          __RequestVerificationToken: valToken,
        },
      }).done((data) => {
        processState(currentState, data);
      }).fail(() => {
        processState(currentState, false);
      });
    }
  }

  function processState(processedState, result) {
    $(`.js-state[data-state="${processedState}"]`).each(function iterator() {
      const $el = $(this);
      const reverse = $el.data('reverse') !== undefined ? $el.data('reverse') : false;
      if (result === !reverse) {
        $el.removeClass('hidden');
      } else {
        $el.remove();
      }
    });
  }
};

export default state;
